import { For } from "solid-js";

import { usePlayer } from "~/components/PlayerContext";
import Image from "~/components/player/Image";
import styles from "~/components/player/RadioShowMetadata.module.scss";
import { conjunctionJoin } from "~/utils/conjunctionJoin";

export default function RadioShowMetadata() {
  const player = usePlayer();
  const radioShow = () => player.metadata?.program;

  const djNames = () => {
    const djs = radioShow()?.djs ?? [];

    if (djs.length > 0) {
      return (
        (djs.length === 1 ? "DJ " : "DJs ") +
        conjunctionJoin(djs.map((dj) => dj.name))
      );
    }

    if (radioShow()?.type === "playlist") {
      return "Playlist";
    }

    if (radioShow()?.type === "commercial_break") {
      return "Intervalo Comercial";
    }

    return "";
  };

  const genre = () => {
    return radioShow()?.type === "commercial_break" ? "" : radioShow()?.genre;
  };

  const djAvatars = () => {
    const djs = radioShow()?.djs ?? [];

    if (djs.length > 0) {
      return djs.map((dj) => dj.avatar);
    }

    return [[{ sizes: "any", src: "/assets/playlist.jpg" }]];
  };

  return (
    <div class={styles.wrapper}>
      <div class={styles.inner}>
        <Image
          displayFallback
          class={styles.cover}
          sources={radioShow()?.cover ?? []}
          alt={`Capa do programa ${radioShow()?.name ?? ""}`}
        />
        <div class={styles.text}>
          <h2>
            <cite>{radioShow()?.name}</cite>
          </h2>
          <div class={styles.dj}>
            <div class={styles.avatars}>
              <For each={djAvatars()}>
                {(avatar, index) => (
                  <Image
                    sources={avatar}
                    alt=""
                    style={{ "z-index": djAvatars().length - index() }}
                  />
                )}
              </For>
            </div>
            {[djNames(), genre()].filter(Boolean).join(" · ")}
          </div>
        </div>
      </div>
      <p>{radioShow()?.description}</p>
    </div>
  );
}
